<script>
import measure from "./measure";
import getInnerText from "./getInnerText";
export default {
  name: "CsTypography",
  props: {
    rows: {
      type: Number,
      required: false,
      default: 2,
    },
    showTooltip: {
      type: Boolean,
      required: false,
      default: true,
    },
    tooltipClass: {
      type: String,
      required: false,
      default: undefined,
    },
    suffix: {
      type: String,
      required: false,
      default: "",
    },
    ellipsisStr: {
      type: String,
      required: false,
      default: "...",
    },
    expandable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      fullText: "",
      ellipsisText: "",
      isEllipsis: true,
      expanded: false,
    };
  },
  mounted() {
    this.updateFullText();
    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.resizeObserver.observe(this.$refs.wrapperRef);
  },
  updated() {
    this.updateFullText();
  },
  beforeDestroy() {
    cancelAnimationFrame(this.rafId);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  },
  methods: {
    handleResize() {
      this.resizeOnNextFrame();
    },
    handleToggleExpanded() {
      this.expanded = !this.expanded;
    },
    renderExpanded() {
      if (!this.expandable || !this.isEllipsis) {
        return null;
      }
      const expandedText = this.expanded ? "折叠" : "展开";
      return (
        <a
          class="cs-typography-operation-expand"
          onClick={this.handleToggleExpanded}
        >
          {expandedText}
        </a>
      );
    },
    updateFullText() {
      const _fullText = getInnerText(this.children);
      if (_fullText !== this.fullText) {
        this.isEllipsis = true;
        this.expanded = false;
        this.fullText = _fullText;
        this.resizeOnNextFrame();
      }
    },
    resizeOnNextFrame() {
      cancelAnimationFrame(this.rafId);
      this.rafId = requestAnimationFrame(() => {
        this.calEllipsis();
      });
    },
    calEllipsis() {
      const ellipsisConfig = {
        rows: this.rows,
        suffix: this.suffix,
        ellipsisStr: this.ellipsisStr,
      };

      const { ellipsis, text } = measure(
        this.$refs.wrapperRef,
        ellipsisConfig,
        this.renderExpanded(),
        this.fullText
      );
      if (this.ellipsisText !== text) {
        this.ellipsisText = text;
      }
      if (this.isEllipsis !== ellipsis) {
        this.isEllipsis = ellipsis;
      }
    },
  },
  render() {
    this.children = this.$slots.default;
    const showEllipsis = this.isEllipsis && !this.expanded;
    const Content = showEllipsis ? this.ellipsisText : this.children;
    return (
      <div class="cs-typography" ref="wrapperRef">
        {this.showTooltip && showEllipsis ? (
          <el-tooltip
            effect="light"
            placement="top"
            open-delay={500}
            content={this.fullText}
            popper-class={this.tooltipClass}
          >
            <span>{this.ellipsisText}</span>
          </el-tooltip>
        ) : (
          Content
        )}
        {showEllipsis ? this.ellipsisStr : null}
        {this.suffix}
        {this.renderExpanded()}
      </div>
    );
  },
};
</script>

<style lang="scss">
.cs-typography {
  line-height: 1.5715;
  white-space: normal;
  overflow-wrap: anywhere;
}

.cs-typography-operation-expand {
  margin: 0 4px;
  color: #165dff;
  cursor: pointer;
}
</style>
